// @flow

import React, {Component} from 'react';
import {connector} from '../store';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Loadable from 'react-loadable';
import {getVideoSlug, getPlayingVideoById, isRoot, isSpecialPath} from '../helpers';
import {toScrollTo} from './ScrollTo.jsx';
import VideoPlayer from './VideoPlayer.jsx';
import ShowBanner from './ShowBanner.jsx';

import bindHistoryToSubnav from './../legacySubnav';

import Core from './../../Core/Core';

let AsyncEpisodeList = Loadable({
  loader: () => import(/* webpackChunkName: "Show.EpisodeList" */ '../components/EpisodeList.jsx').then(dep => dep.default),
  loading: () => null
});

let AsyncAbout = Loadable({
  loader: () => import(/* webpackChunkName: "Show.About" */ '../components/About.jsx').then(component => {
    return toScrollTo(component.default, /\/about\//);
  }),
  loading: () => null
});

let AsyncSchedule = Loadable({
  loader: () => import(/* webpackChunkName: "Show.Airings" */ '../components/Airings.jsx').then(component => {
    return toScrollTo(component.default, /\/schedule\//);
  }),
  loading: () => null
});

let AsyncSponsors = Loadable({
  loader: () => import(/* webpackChunkName: "Show.Sponsors" */ '../components/Sponsors.jsx').then(dep => dep.default),
  loading: () => null
});

let AsyncRelated = Loadable({
  loader: () => import(/* webpackChunkName: "Show.RelatedShows" */ '../components/RelatedShows.jsx').then(dep => dep.default),
  loading: () => null
});

class ShowPage extends Component<*, *> {
  componentDidMount() {
    this.props.getShowData();

    // When the page loads check the url to determine what video to load
    if (!this.props.player.livestreamOverride) {
      this.loadVideoFromPath(window.location.pathname);
    }

    window.addEventListener('popstate', function(event) {
      let path = window.location.pathname;

      // Do not perform loading for special paths
      if (!isSpecialPath(path)) {

        // Check if livestream needs to be loaded
        if (isRoot(this.props.show.slug) && this.props.show.livestream.isLive) {
          this.props.loadLivestream();
        } else {

          // Check if a video needs to be loaded, and if so perform the load action
          let playing = getPlayingVideoById(this.props.player.container, this.props.player.currentlyPlaying.id);

          if (playing && playing.slug !== window.location.pathname) {
            this.loadVideoFromPath(window.location.pathname);
          }
        }
      }
    }.bind(this));

    this.connectHistoryToSubnav(this.props.history);

    this.props.history.listen(function(event) {

      // Whenever a history event occurs, update tracking settings
      // and trigger a pageview
      Core.updateTrackingPath('/show' + event.pathname);
      Core.trackPageView();
    });
  }

  connectHistoryToSubnav(history) {
    bindHistoryToSubnav(history);
  }

  shouldShowSponsors() {
    return window && window.initialShowSponsors;
  }

  loadVideoFromPath(path) {
    var slug = getVideoSlug(path);

    if (slug) {
      this.props.loadVideoBySlug(slug);
    } else {
      this.props.getVideoData();
    }
  }

  renderVideoPlayer() {
    return <Switch>
      <Route exact path={`/${this.props.show.slug}`} component={VideoPlayer} />
      <Route exact path={`/${this.props.show.slug}/about`} component={VideoPlayer} />
      <Route exact path={`/${this.props.show.slug}/schedule`} component={VideoPlayer} />
      <Route path={`/${this.props.show.slug}/video/:videoId`} component={VideoPlayer} />
    </Switch>;
  }

  renderPlaceholder() {
    return <ShowBanner banner={this.props.show.mezzanine} />;
  }

  renderExtras() {
    return <div>
      {(this.props.videos.fullLengthVideos.length > 0 || this.props.show.seasons.length > 0) && <AsyncEpisodeList/>}
      {(this.props.videos.fullLengthVideos.length > 1 || this.props.show.seasons.length > 0) &&
        this.props.show.blocks.length > 0 &&
        <div className="full-row" dangerouslySetInnerHTML={{__html: this.props.show.promos[0]}}/>
      }
      <Route path="/" component={AsyncAbout} />
      <Route path="/" component={AsyncSchedule} />
      { this.shouldShowSponsors() ? <AsyncSponsors/> : "" }
      <AsyncRelated/>
    </div>;
  }

  render() {
    return (
      <div>
        <div className="show-information dark inner-page-content">
          {this.props.player.currentlyPlaying.id || this.props.show.livestream.isLive ? this.renderVideoPlayer() : this.renderPlaceholder()}
          {this.props.show.blocks.length > 0 &&
            <div className="full-row" dangerouslySetInnerHTML={{__html: this.props.show.blocks[0]}}/>
          }
          {this.props.show.fetchedShow && this.renderExtras()}
        </div>
      </div>
    );
  }
}

export default connector(ShowPage);